import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { Router } from '@angular/router';
import { MarketingService } from '../../../shared/_services/marketing.service';

@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.scss']
})
export class ConfirmModalComponent implements OnInit {
  errorDetails: any;
  confirmObject: any = [];
  constructor(
    public bsModalRef: BsModalRef, 
    private router: Router,
    private marketingService: MarketingService
  ) { }

  confirmClose(close) {
    if(this.confirmObject.type == 'reward-add') {
      if(close) {
        this.bsModalRef.hide();
        this.bsModalRef = null;
        this.router.navigate(['/marketing/rewards-catalog']);
      } else {
        this.bsModalRef.hide();
        this.bsModalRef = null;
      }
    } else if(this.confirmObject.type == 'update-brand'){
      if(close) {
        this.bsModalRef.hide();
        this.bsModalRef = null;
        this.router.navigate(['/settings/hca-brand']);
      } else {
        this.bsModalRef.hide();
        this.bsModalRef = null;
      }
    }
    
  }
  ngOnInit() {
    setTimeout(() => {
      
    }, 200);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/modals/confirm-modal/confirm-modal.component.ts